import Vue from 'vue'

/*
results: [] to append results to
endPoint: GraphQL endpoint
fields: GraphQL fields to retrieve
increment: fetch size, default = 100
filters: any filters to apply to query (optional)
parameters: optional parameters
*/

const lazyListLoad = {
	install(Vue) {
		Vue.prototype.$lazyListLoad = async function(results, endPoint, fields, increment = 100, filters = [], parameters = []) {
      let more = false;
      let after;
      do {
        const query = await Vue.prototype.$apiCall(`query ${endPoint}LazyListLoad($after: String, $first:Int, $filters:[FilterInput], $parameters: [ParameterInput]) {
                                                        ${endPoint}(first:$first, after:$after, filters:$filters, parameters:$parameters) {
                                                          pageInfo {
                                                            hasNextPage
                                                            endCursor
                                                          }
                                                          edges {
                                                            cursor
                                                            node {
                                                              ${fields}
                                                            }
                                                          }
                                                        }
                                                      }`,
                                                    {after, first:increment, filters, parameters});
        const queryResults =  query.data[endPoint];
        results.push(...queryResults.edges.map(edge => edge.node));
        after = queryResults.pageInfo.endCursor;
        more = queryResults.pageInfo.hasNextPage
      } while (more);
    }
	}
}

Vue.use(lazyListLoad);
